import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DONATE_URL } from '../utils/donate';

const Navbar: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Bootstrap dropdown
    const initBootstrap = () => {
      if (window.bootstrap) {
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        dropdownElementList.forEach((dropdownToggleEl) => {
          new window.bootstrap.Dropdown(dropdownToggleEl);
        });
      }
    };
    initBootstrap();

    // Handle scroll for navbar background
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const fixedTopElement = document.querySelector('.fixed-top') as HTMLElement;
      
      if (!fixedTopElement) return;

      if (window.innerWidth < 992) {
        // Mobile/Tablet: Add bg-dark shadow when scrolled
        if (scrollTop > 45) {
          fixedTopElement.classList.add('bg-dark', 'shadow');
        } else {
          fixedTopElement.classList.remove('bg-dark', 'shadow');
        }
      } else {
        // Desktop: Add bg-dark shadow and adjust top position
        if (scrollTop > 45) {
          fixedTopElement.classList.add('bg-dark', 'shadow');
          fixedTopElement.style.top = '-45px';
        } else {
          fixedTopElement.classList.remove('bg-dark', 'shadow');
          fixedTopElement.style.top = '0';
        }
      }
    };

    // Handle window resize
    const handleResize = () => {
      handleScroll();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="container-fluid fixed-top px-0" data-aos="fade" data-aos-delay="100">
      <div className="top-bar text-white-50 row gx-0 align-items-center d-none d-lg-flex">
        <div className="col-lg-6 px-5 text-start">
          <small><i className="fa fa-map-marker-alt me-2"></i>Plot 45, APMC Market Kamalnagar Dist. Bidar Karnataka 585417</small>
          <small className="ms-4"><i className="fa fa-envelope me-2"></i>info@thehumanitytrust.in</small>
        </div>
        <div className="col-lg-6 px-5 text-end">
          <small>Follow us:</small>
          <a className="text-white-50 ms-3" href="https://www.youtube.com/@thehumanitytrust" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
          <a className="text-white-50 ms-3" href="https://www.instagram.com/1humanitytrust/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a className="text-white-50 ms-3" href="https://www.linkedin.com/company/the-humanity-trust/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-dark py-lg-0 px-lg-5" data-aos="fade" data-aos-delay="100">
        <Link to="/" className="navbar-brand ms-4 ms-lg-0">
          <h1 className="fw-bold text-primary m-0">Humanity<span className="text-white">Trust</span></h1>
        </Link>
        <button
          type="button"
          className="navbar-toggler me-4"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            <Link to="/" className={`nav-item nav-link ${isActive('/') ? 'active' : ''}`}>
              Home
            </Link>
            <Link to="/about" className={`nav-item nav-link ${isActive('/about') ? 'active' : ''}`}>
              About
            </Link>
            <Link to="/causes" className={`nav-item nav-link ${isActive('/causes') ? 'active' : ''}`}>
              Causes
            </Link>
            <Link to="/events" className={`nav-item nav-link ${isActive('/events') ? 'active' : ''}`}>
              Events
            </Link>
            <Link to="/contact" className={`nav-item nav-link ${isActive('/contact') ? 'active' : ''}`}>
              Contact
            </Link>
          </div>
          <div className="d-none d-lg-flex ms-2">
            <a
              className="btn btn-outline-primary py-2 px-3"
              href={DONATE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate Now
              <div className="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2">
                <i className="fa fa-arrow-right"></i>
              </div>
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;

